
export const FETCH_STOCKCONSUMPTION_REQUEST = "FETCH_STOCKCONSUMPTION_REQUEST";
export const FETCH_STOCKCONSUMPTION_SUCCESS = "FETCH_STOCKCONSUMPTION_SUCCESS";
export const FETCH_STOCKCONSUMPTION_FAILURE = "FETCH_STOCKCONSUMPTION_FAILURE";

export const CREATE_STOCKCONSUMPTION_REQUEST = "CREATE_STOCKCONSUMPTION_REQUEST";
export const CREATE_STOCKCONSUMPTION_SUCCESS = "CREATE_STOCKCONSUMPTION_SUCCESS";
export const CREATE_STOCKCONSUMPTION_FAILURE = "CREATE_STOCKCONSUMPTION_FAILURE";

export const UPDATE_STOCKCONSUMPTION_REQUEST = "UPDATE_STOCKCONSUMPTION_REQUEST";
export const UPDATE_STOCKCONSUMPTION_SUCCESS = "UPDATE_STOCKCONSUMPTION_SUCCESS";
export const UPDATE_STOCKCONSUMPTION_FAILURE = "UPDATE_STOCKCONSUMPTION_FAILURE";

export const DELETE_STOCKCONSUMPTION_REQUEST = "DELETE_STOCKCONSUMPTION_REQUEST";
export const DELETE_STOCKCONSUMPTION_SUCCESS = "DELETE_STOCKCONSUMPTION_SUCCESS";
export const DELETE_STOCKCONSUMPTION_FAILURE = "DELETE_STOCKCONSUMPTION_FAILURE";
